import * as React from 'react';
import PropTypes from 'prop-types';
import CustomCheckbox from './CustomCheckbox';

const getCheckedLabel = checked => (checked ? 'Décocher' : 'Cocher');

const ToggleCheckboxes = ({
  items, className, checked, onChange, type, showCheckAll, alwaysBorders, noBorders, disabled, labelChoose,
}) => {
  const handleChange = (event) => {
    const { target: { checked: isChecked, value, type: inputType } } = event;

    if (inputType === 'checkbox') {
      let list = [...checked];
      if (isChecked) {
        list.push(value);
      } else {
        list = list.filter(c => String(c) !== value);
      }
      onChange(list);
    }

    if (inputType === 'radio') {
      onChange(value);
    }
  };

  const checkAll = (event) => {
    if (event.target.checked) {
      onChange(items.map(i => String(i.value)));
    } else {
      onChange([]);
    }
  };

  const checkOneToggleOthers = value => onChange([value]);

  const allChecked = items.every(i => checked.includes(String(i.value)));

  return (
    <div className={`toggle-checkbox-container ${className}`}>
      {['checkbox', 'switch'].includes(type) && showCheckAll && (
        <div
          className={`
            toggle-checkbox
            ${alwaysBorders ? 'borders' : ''}
            ${noBorders ? 'no-borders' : ''}
            ${allChecked ? 'active' : ''}
          `}
          key="all"
        >
          <CustomCheckbox
            type={type}
            id="all"
            checked={allChecked}
            indeterminate={!allChecked && checked.length > 0}
            label="Tout"
            onChange={event => checkAll(event)}
          />
        </div>
      )}
      {items.map(i => (
        <div
          className={`
            toggle-checkbox
            ${alwaysBorders ? 'borders' : ''}
            ${noBorders ? 'no-borders' : ''}
            ${checked.includes(String(i.value)) ? 'active' : ''}
          `}
          key={i.id}
        >
          <CustomCheckbox
            type={type}
            id={i.id}
            checked={['checkbox', 'switch'].includes(type) ? checked.includes(String(i.value)) : checked === String(i.value)}
            showLabel={!labelChoose}
            label={labelChoose
              ? getCheckedLabel(['checkbox', 'switch'].includes(type) ? checked.includes(String(i.value)) : checked === String(i.value))
              : i.label
            }
            value={i.value}
            onChange={event => handleChange(event)}
            disabled={i.disabled || disabled}
          />
          {labelChoose && (
            <button
              type="button"
              className="toggle-checkbox-label btn-unstyled text-left"
              onClick={() => checkOneToggleOthers(i.value)}
            >
              {i.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

ToggleCheckboxes.propTypes = {
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  checked: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  showCheckAll: PropTypes.bool,
  alwaysBorders: PropTypes.bool,
  noBorders: PropTypes.bool,
  disabled: PropTypes.bool,
  labelChoose: PropTypes.bool,
};

ToggleCheckboxes.defaultProps = {
  className: '',
  checked: [],
  type: 'checkbox',
  showCheckAll: true,
  alwaysBorders: false,
  noBorders: false,
  disabled: false,
  labelChoose: false,
};

export default ToggleCheckboxes;
